import React from 'react';
import {
  Brain, Volume2, Mic2, PenLine, Headphones, BookOpen, Mic, Library,
  BookOpenText, WholeWord, Clock, Crosshair, Flame,
} from 'lucide-react';
import type { IconMotion } from './AnimatedIcon';

/**
 * Ícone de cada seção do app (o mesmo dos hubs em App.tsx) + a micro-animação dele.
 * Métricas sem seção própria (leitura, palavras, tempo, precisão, consistência) têm ícones próprios.
 */
export const SECTION_ICONS = {
  flashcards: { Icon: Brain, motion: 'pulse' },
  shadowing: { Icon: Volume2, motion: 'wobble' },
  pronunciation: { Icon: Mic2, motion: 'bounce' },
  writing: { Icon: PenLine, motion: 'swing' },
  listening: { Icon: Headphones, motion: 'pop' },
  grammar: { Icon: BookOpen, motion: 'flip' },
  active_voice: { Icon: Mic, motion: 'swing' },
  library: { Icon: Library, motion: 'slide' },
  reading: { Icon: BookOpenText, motion: 'flip' },
  words: { Icon: WholeWord, motion: 'pop' },
  time: { Icon: Clock, motion: 'spin' },
  accuracy: { Icon: Crosshair, motion: 'spin' },
  consistency: { Icon: Flame, motion: 'pulse' },
} satisfies Record<string, { Icon: React.FC<any>; motion: IconMotion }>;

export type SectionKey = keyof typeof SECTION_ICONS;

/** Métrica do /reports -> seção correspondente no app */
export const METRIC_SECTION: Record<string, SectionKey> = {
  books_read: 'library',
  pages_read: 'reading',
  unique_words: 'words',
  words_written: 'writing',
  pronunciation_count: 'pronunciation',
  active_voice_duration: 'active_voice',
  cards_reviewed: 'flashcards',
  total_quizzes_attempted: 'grammar',
  listening_count: 'listening',
  shadowing_duration: 'shadowing',
  tempo_estimado: 'time',
  taxa_precisao: 'accuracy',
  consistencia: 'consistency',
};

export const metricIcon = (key: string, size = 20) => {
  const s = SECTION_ICONS[METRIC_SECTION[key] || 'time'];
  return React.createElement(s.Icon, { size, strokeWidth: 1.75 });
};

export const metricMotion = (key: string): IconMotion => SECTION_ICONS[METRIC_SECTION[key] || 'time'].motion as IconMotion;
